import {
  createEmail,
  createPhone,
  MockContact,
  MockEmail,
  MockPhone,
} from '@dapi/sdk/spec';
import {
  traveler,
  traveler2,
} from './traveler';

export const contactPhoneId = 'OT43';
export const contactEmailId = 'OT44';
export const contactNotificationPhoneId = 'OT45';
export const contactNotificationEmailId = 'OT46';

export const contactPhone: MockPhone = createPhone({
  template: {
    id: contactPhoneId,
    travelerIds: [],
    category: 'personal',
    contactType: 'Phone',
    deviceType: 'landline',
    purpose: 'standard',
    countryPhoneExtension: '358',
    number: '2317924121'
  }
});

export const contactEmail: MockEmail = createEmail({
  template: {
    id: contactEmailId,
    travelerIds: [],
    category: 'personal',
    contactType: 'Email',
    purpose: 'standard',
    address: 'test@test.com'
  }
});

export const notificationContactPhone: MockPhone = {
  ...contactPhone,
  id: contactNotificationPhoneId,
  purpose: 'notification'
};

export const notificationContactEmail: MockEmail = {
  ...contactEmail,
  id: contactNotificationEmailId,
  purpose: 'notification'
};

export const contacts: MockContact[] = [contactPhone, contactEmail];

export const contactsForOneTraveler: MockContact[] = [
  {
    ...contactEmail,
    travelerIds: [traveler.id]
  },
  {
    ...contactPhone,
    travelerIds: [traveler.id]
  }
];

export const contactsForTwoTravelers: MockContact[] = [
  {
    ...contactEmail,
    travelerIds: [traveler.id]
  },
  {
    ...contactPhone,
    travelerIds: [traveler.id]
  },
  {
    ...contactEmail,
    travelerIds: [traveler2.id],
    id: 'OT47'
  },
  {
    ...contactPhone,
    travelerIds: [traveler2.id],
    id: 'OT48'
  }
];
